export const CHANGE_NAVIGATION_THEME = 'CHANGE_NAVIGATION_THEME';
export const ENABLE_ALL_VISIBILITY = 'ENABLE_ALL_VISIBILITY';

export const RECEIVE_COMPANIES = 'RECEIVE_COMPANIES';
export const FETCH_COMPANY = 'FETCH_COMPANY';
export const FIND_COMPANY = 'FIND_COMPANY';

export const RECEIVE_PERSONS = 'RECEIVE_PERSONS';
export const FETCH_PERSON = 'FETCH_PERSON';
export const RECEIVE_NAVIGATION = 'RECEIVE_NAVIGATION';
export const RECEIVE_GLOBAL = 'RECEIVE_GLOBAL';

export const RECEIVE_PAGE = 'RECEIVE_PAGE';
export const THEME_SWITCHING_END = 'THEME_SWITCHING_END';
export const THEME_ONLY_WHITE = 'THEME_ONLY_WHITE';
export const THEME_SWITCHED = 'THEME_SWITCHED';
export const CHANGE_THEME = 'CHANGE_THEME';
export const PAGE_ANIMATION_FIRST_VISIT = 'PAGE_ANIMATION_FIRST_VISIT';
export const PAGE_ANIMATION = 'PAGE_ANIMATION';
export const PAGE_LOADED = 'PAGE_LOADED';

export const RECEIVE_CITIES = 'RECEIVE_CITIES';
export const FETCH_CITY = 'FETCH_CITY';

export const POPUP_ANIMATION = 'POPUP_ANIMATION';
export const POPUP_STATE = 'POPUP_STATE';

export const SWITCH_LANG = 'SWITCH_LANG';

export const CAREER_SLIDE = 'CAREER_SLIDE';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js